export const drawerWidth = 240;

export const roles = {
  Uber: 'Uber',
  Company: 'Company',
  Client: 'Client',
};

export const KEY = {
  /* Google Recapcha key account details - faisal.khan@azularc.com */
  SITE: '6LdSSgUgAAAAAL4KHiLHkQTdMD_jKZBS7pqqU0_o',
  SECRECT: '6LdSSgUgAAAAAD8jpaHwU9VTK_SexjvsY8eL6gUW',
};

export const a = 'a';
